import { useEffect, useState } from "react";
import { Briefcase, Plus, Trash2, Loader2, RefreshCw, Power } from "lucide-react";
import { api, apiErr } from "@/lib/api";
import { toast } from "sonner";

const emptyForm = { name: "", type: "electronics", code: "", is_active: true };
const TYPES = ["electronics", "grocery", "pharmacy", "restaurant", "fashion", "hardware", "general"];

export default function AdminBusinesses() {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(emptyForm);
  const [saving, setSaving] = useState(false);

  const load = () => api.get("/admin/businesses").then((r) => setRows(r.data)).catch((e) => toast.error(apiErr(e)));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!form.name.trim()) return toast.error("Business ka naam daalein");
    setSaving(true);
    try {
      await api.post("/admin/businesses", form);
      toast.success("Business added — app par bhi sync hoga");
      setForm(emptyForm); load();
    } catch (e) { toast.error(apiErr(e)); } finally { setSaving(false); }
  };
  const toggle = async (b) => { try { await api.put(`/admin/businesses/${b.id}`, { is_active: !b.is_active }); load(); } catch (e) { toast.error(apiErr(e)); } };
  const del = async (b) => { if (!window.confirm("Ye business delete karein? (app se bhi hat jayega)")) return; try { await api.delete(`/admin/businesses/${b.id}`); toast.success("Deleted"); load(); } catch (e) { toast.error(apiErr(e)); } };

  return (
    <div className="p-4 md:p-6 space-y-5" data-testid="admin-businesses-page">
      <div className="flex items-center justify-between flex-wrap gap-3">
        <div className="flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-indigo-50 text-indigo-600 flex items-center justify-center"><Briefcase size={22} /></div>
          <div>
            <h1 className="text-xl md:text-2xl font-extrabold text-slate-900">Businesses</h1>
            <p className="text-sm text-slate-500">Multi-business registry — app ke saath 2-way sync. Naya business app me banega to yahan bhi apne aap aayega.</p>
          </div>
        </div>
        <button onClick={load} data-testid="businesses-refresh" className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-600 border border-slate-200 rounded-lg px-3 py-2 hover:bg-slate-50"><RefreshCw size={15} /> Refresh</button>
      </div>

      <div className="bg-white border border-slate-200 rounded-2xl p-4 md:p-5" data-testid="business-add-form">
        <h2 className="font-bold text-slate-800 mb-3 flex items-center gap-2"><Plus size={17} /> Add Business</h2>
        <div className="grid md:grid-cols-4 gap-3">
          <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Business name" data-testid="business-name" className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm md:col-span-2" />
          <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} data-testid="business-type" className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm">
            {TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
          </select>
          <input value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} placeholder="Code (optional)" data-testid="business-code" className="w-full border border-slate-200 rounded-lg px-3 py-2 text-sm" />
        </div>
        <button onClick={add} disabled={saving} data-testid="business-save-btn" className="mt-3 inline-flex items-center gap-2 bg-indigo-600 text-white font-bold px-4 py-2 rounded-lg hover:bg-indigo-700 disabled:opacity-60">{saving ? <Loader2 size={16} className="animate-spin" /> : <Plus size={16} />} Add Business</button>
      </div>

      {rows.length === 0 ? (
        <div className="text-center py-14 text-slate-400" data-testid="businesses-empty">Koi business nahi. Upar se add karein — ya app me banayein, sync ho jayega.</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="businesses-grid">
          {rows.map((b) => (
            <div key={b.id} data-testid={`business-card-${b.id}`} className={`bg-white border rounded-2xl p-4 ${b.is_active ? "border-slate-200" : "border-slate-200 opacity-60"}`}>
              <div className="flex items-center justify-between">
                <span className={`text-[10px] font-bold px-2 py-0.5 rounded-full ${b.is_active ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-600"}`}>{b.is_active ? "ACTIVE" : "INACTIVE"}</span>
                {b._sync_origin && <span className="text-[10px] text-slate-400">from {b._sync_origin === "owner" ? "app" : "web"}</span>}
              </div>
              <div className="text-base font-bold text-slate-800 mt-2">{b.name}</div>
              <div className="text-xs text-slate-500 mt-0.5 capitalize">{b.type}{b.code ? ` · ${b.code}` : ""}</div>
              <div className="flex items-center gap-1 pt-3">
                <button onClick={() => toggle(b)} data-testid={`business-toggle-${b.id}`} className="flex-1 text-xs font-semibold px-2 py-1.5 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-700 inline-flex items-center justify-center gap-1"><Power size={13} /> {b.is_active ? "Disable" : "Enable"}</button>
                <button onClick={() => del(b)} data-testid={`business-delete-${b.id}`} className="p-1.5 rounded-lg hover:bg-red-50 text-red-500"><Trash2 size={15} /></button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
